import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__information',
    path: '/information',
    redirect: { name: '__information_contact' },
    component: () =>
      interopDefault(
        import(
          '~/pages/car/information/index.vue' /* webpackChunkName: "pages-information-index.vue" */
        )
      ),
    children: [
      {
        path: '/dealers/register',
        name: '__managers_register',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/managers/register.vue' /* webpackChunkName: "pages-managers-register.vue" */
            )
          )
      },
      {
        path: 'dealers_faq',
        name: '__information_dealers_faq',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/information/dealers-faq.vue' /* webpackChunkName: "pages-information-dealers-faq.vue" */
            )
          )
      },
      {
        path: 'users_faq',
        name: '__information_users_faq',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/information/users-faq.vue' /* webpackChunkName: "pages-information-users-faq.vue" */
            )
          )
      },
      {
        path: 'terms',
        name: '__information_terms',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/information/terms.vue' /* webpackChunkName: "pages-information-terms.vue" */
            )
          )
      },
      {
        path: 'support',
        name: '__information_support',
        redirect: { name: '__information_contact' }
      },
      {
        path: 'contact',
        name: '__information_contact',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/information/contact.vue' /* webpackChunkName: "pages-information-contact.vue" */
            )
          ),
        meta: { showOneTap: true }
      },
      {
        name: '__information_market_guide',
        path: '/information/simboulos',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/information/market-guide.vue' /* webpackChunkName: "pages-information-market-guide.vue" */
            )
          )
      },
      {
        name: '__information_careers',
        path: '/information/careers',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/information/careers.vue' /* webpackChunkName: "pages-information-careers.vue" */
            )
          )
      },
      {
        name: '__information_privacy',
        path: '/information/privacy',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/information/privacy.vue' /* webpackChunkName: "pages-information-privacy.vue" */
            )
          )
      }
    ]
  }
]
